import { render, staticRenderFns } from "./BTableHeaderConfiguration.vue?vue&type=template&id=af448736"
import script from "./BTableHeaderConfiguration.vue?vue&type=script&lang=js"
export * from "./BTableHeaderConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports